module.exports = __webpack_public_path__ + "img/icon-add-custom.930de177.svg";